import Enumeration from 'Lib/utilities/Enumeration';

const LedgerTypes = new Enumeration([
    { id: 1, key: 'Manager', name: 'Manager', color: '#4666c0' },
    { id: 2, key: 'Portfolio', name: 'Portfolio', color: '#f74a30' },
    { id: 3, key: 'Property', name: 'Property', color: '#00a499' },
    { id: 4, key: 'Unit', name: 'Unit', color: '#50C878' }
]);

export default LedgerTypes;
